import { FC } from 'react';
import { Box, Typography } from '@material-ui/core';
import { KeyboardTimePicker } from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { useStyles } from '../../styles';

interface Props {
    value: Date;
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
}
const TimeField: FC<Props> = ({ value, setFieldValue }) => {
    const classes = useStyles();

    return (
        <Box className={classes.row}>
            <Typography className={classes.label}>Start time</Typography>
            <KeyboardTimePicker
                fullWidth
                inputVariant="outlined"
                minutesStep={15}
                ampm
                format="hh:mm A"
                value={value}
                InputProps={{ className: classes.field }}
                onChange={(date: MaterialUiPickersDate | null) => {
                    setFieldValue('date', date, true);
                }}
            />
        </Box>
    );
};

export default TimeField;
